var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUppiesImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3781_25145)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.0753,
    cy: 39.9071,
    rx: 27.5,
    ry: 31.6667,
    fill: "#94DDDF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3781_25145)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3781_25145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.2464 35.5809C73.5273 16.4508 57.8337 2.67516 40.8215 4.09477C40.6592 4.08564 40.4991 4.09229 40.3413 4.11472L29.3399 5.67838C13.2087 7.97115 1.52173 22.3857 0.898717 39.3017C0.905448 39.349 0.898637 39.4144 0.889583 39.464C0.82036 41.696 0.93149 43.9507 1.25679 46.2394C2.31568 53.6894 5.41559 60.318 9.84447 65.5338C9.92331 65.6353 10.0022 65.7368 10.1126 65.8339C17.4341 74.2939 28.2777 78.9845 39.5317 77.3849L50.5331 75.8212C50.691 75.7988 50.8466 75.7606 50.9999 75.7066C67.7339 72.3298 78.9541 54.7449 76.2328 35.599L76.2464 35.5809ZM22.3726 12.7394C19.5907 15.4858 17.2728 18.7782 15.5387 22.4385L10.7719 23.116C13.661 18.6313 17.6385 15.0065 22.3884 12.7372L22.3726 12.7394ZM8.38032 54.0996L14.4571 53.2359C15.4676 55.9263 16.7599 58.4479 18.2824 60.7758L12.7896 61.5565C11.0235 59.3277 9.54177 56.833 8.38032 54.0996ZM13.0265 48.6084L6.80761 49.4923C6.46581 48.2204 6.18266 46.908 5.99197 45.5664C5.80128 44.2247 5.72557 42.899 5.68142 41.5687L11.9003 40.6848C11.958 41.997 12.0675 43.3341 12.2582 44.6757C12.4489 46.0174 12.714 47.3162 13.0265 48.6084ZM11.9849 35.8419L5.90808 36.7057C6.26189 33.7569 7.00566 30.9459 8.07849 28.2974C8.14162 28.2885 8.207 28.2953 8.27014 28.2863L13.5735 27.5325C12.7578 30.1766 12.2192 32.9584 12.0007 35.8397L11.9849 35.8419ZM16.8381 65.7958L21.3208 65.1587C21.4155 65.1452 21.4922 65.1182 21.5846 65.089C24.288 68.1346 27.4314 70.6508 30.8684 72.5133C25.6743 71.6573 20.8466 69.3001 16.8223 65.798L16.8381 65.7958ZM48.6898 71.2363C33.6635 73.372 19.4478 61.1576 17.0092 44.0005C14.5706 26.8433 24.8042 11.1539 39.8305 9.01816C54.8568 6.88243 69.0726 19.0968 71.5112 36.254C73.9498 53.4111 63.7004 69.1028 48.6741 71.2385L48.6898 71.2363Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1437 45.7661C39.6574 49.3806 38.8855 50.6337 36.9282 50.9118C34.971 51.19 33.7545 49.7687 33.2991 46.5646L31.0692 30.8754L25.2607 31.7009L27.5063 47.5007C28.213 52.4726 29.8483 54.6878 32.7851 56.09C34.2343 56.7697 35.9206 56.9648 37.8305 56.6933C41.2714 56.2043 43.5951 54.1993 44.72 51.2375C45.296 49.7386 45.3719 47.6667 44.9905 44.9834L42.7515 29.231L36.9273 30.0588L39.1617 45.7796L39.1437 45.7661Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0772 27.7508C58.7879 27.29 56.9189 27.1691 54.4926 27.5462L46.7901 28.641L50.4491 54.3846L56.0208 53.5927L54.8744 45.5271L57.5893 45.1412C64.108 44.2147 65.8609 39.6661 65.1833 34.8994C64.6898 31.4269 62.7212 28.6794 60.0772 27.7508ZM56.5472 39.3957L54.0533 39.7502L53.1829 33.626L55.4558 33.3029C58.0443 32.935 59.3131 33.7047 59.6115 35.804C59.9234 37.998 58.8832 39.0637 56.5472 39.3957Z",
    fill: "#194142"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3781_25145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3781_25145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.5637,
    height: 86.5637,
    fill: "white",
    transform: "translate(-8.42401 3.75903) rotate(-8.08942)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3781_25145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.7432,
    height: 72.4272,
    fill: "white",
    transform: "translate(-3.83801 10.394) rotate(-8.08942)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUppiesImage);
export default __webpack_public_path__ + "static/media/uppies_image.0afc3b49f47a50922974f85923346835.svg";
export { ForwardRef as ReactComponent };